import styled from 'styled-components';

export const CouponIssueHistoryListWrapStyle = styled.div``;

export const CouponIssueHistoryDetailWrapStyle = styled.div`
  padding-bottom: 30px;

  .panel {
    .panel-body {
      & > div {
        padding: 20px 0;
      }

      & > div:not(:last-child) {
        border-bottom: 1px solid #efefef;
      }
    }
  }
`;
